module.exports = __webpack_public_path__ + "files/OBSERVA4.7136cc8b9051bf32af4b9b6547f26806.zip";